const dim = (d) => `H ${d.h} × W ${d.w} × D ${d.d} cm (${+(d.h * 10).toFixed(0)} × ${+(d.w * 10).toFixed(0)} × ${+(d.d * 10).toFixed(0)} mm)`;
const Row = ({ k, v, id }) => <div data-testid={id} className="flex justify-between gap-4 rounded-xl bg-white/5 px-4 py-3 text-sm"><span className="text-slate-500 shrink-0">{k}</span><span className="text-right">{v}</span></div>;

export function DimRows({ p }) {
  const hsn = p.hsn && <Row id="product-hsn" k="HSN code · GST" v={`${p.hsn} · ${p.gst_rate ?? 18}% GST`} />;
  if (!p.dimensions?.h) return hsn ? <div className="grid sm:grid-cols-2 gap-2">{hsn}</div> : null;
  const ac = !!p.dimensions_outdoor?.h;
  return (
    <div className="grid sm:grid-cols-2 gap-2" data-testid="product-dimensions">
      {hsn}
      <Row id="product-dim-main" k={ac ? "Indoor unit size" : "Product size"} v={dim(p.dimensions)} />
      {ac && <Row id="product-dim-outdoor" k="Outdoor unit size" v={dim(p.dimensions_outdoor)} />}
      {p.weight_kg > 0 && <Row id="product-dim-weight" k="Weight" v={`${p.weight_kg} kg`} />}
    </div>
  );
}

export default function VariantInfo({ v }) {
  const rows = [["Colour", v.color], ["RAM", v.ram], ["Storage", v.storage && `${v.storage}${v.storage_type ? ` ${v.storage_type}` : ""}`], ["Processor", v.processor], ["Size", v.dimensions?.h && dim(v.dimensions)], ["Weight", v.weight_kg > 0 && `${v.weight_kg} kg`]].filter(([, x]) => x);
  if (!rows.length && !v.description) return null;
  return (
    <div className="rounded-2xl border border-white/10 bg-white/[0.03] p-4 space-y-2 text-sm" data-testid="variant-info">
      <p className="font-semibold">{v.label}</p>
      {v.description && <p className="text-slate-300" data-testid="variant-info-description">{v.description}</p>}
      {rows.length > 0 && <div className="grid grid-cols-2 gap-x-4 gap-y-1">{rows.map(([k, x]) => <p key={k} data-testid={`variant-info-${k.toLowerCase()}`}><span className="text-slate-500">{k}: </span>{x}</p>)}</div>}
    </div>
  );
}
